/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
const rowCss = ":host{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}";
const Row = /*@__PURE__*/proxyCustomElement(class Row extends HTMLElement {
  constructor(registerHost) {
    super();
    if (registerHost !== false) {
      this.__registerHost();
    }
    this.__attachShadow();
  }
  render() {
    return h(Host, {
      key: '65592a79621bd8f75f9566db3e8c05a4b8fc6048',
      class: getIonMode(this)
    }, h("slot", {
      key: '56f09784db7a0299c9ce76dfcede185b295251ff'
    }));
  }
  static get style() {
    return rowCss;
  }
}, [257, "ion-row"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ion-row"];
  components.forEach(tagName => {
    switch (tagName) {
      case "ion-row":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Row);
        }
        break;
    }
  });
}
const IonRow = Row;
const defineCustomElement = defineCustomElement$1;
export { IonRow, defineCustomElement };